export default function(element) {
    return element && element.nodeType == 1;
}
